const languages = {
    english: 'en',
};

module.exports = languages;